// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__ESHbT","title":"ClientCherryInfo_title__1Cm7y","itemText":"ClientCherryInfo_itemText__3rPrq"};